// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"9506fe1e","262":"2ee04f39","507":"9d24cb83","645":"487b2856","660":"5ac206c1","667":"3ae35af8","691":"5d7a65ac","752":"dfe075e9","766":"e5181ac0"}[chunkId] + ".chunk.css";
};